import React, { useEffect } from "react";
import withIntl from "../../utils/withIntl";
import { CircularProgress, DialogContent, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import cloudStore from "../../store/CloudStore";
import { useDialog } from "../Dialogs/DialogProvider";
import { updatePrinters } from "./PrinterApi";

function DuplicatePrinter(props) {
  const printer = props.printer;
  const [open, setOpen] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [openDialog, closeDialog] = useDialog();
  let loading = open && options.length === 0;

  const search = (searchValue) => {
    return cloudStore.merchants.reduce((merchants, merchant) => {
      if (merchants.length > 9) {
        return merchants;
      }
      if (merchant.name == null || merchant.merchant_id == null) {
        return merchants;
      }
      let searchValues = searchValue.split(/\s/);

      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (
            merchant.name.toLowerCase().includes(value.toLowerCase()) ||
            merchant.merchant_id.toString().toLowerCase().includes(value.toLowerCase())
          ) {
            return true;
          }
          return false;
        })
      ) {
        merchants.push(merchant);
      }

      return merchants;
    }, []);
  };

  useEffect(() => {
    if (selectedOption) {
      let newData = { ...printer };

      newData.merchant_id = selectedOption.merchant_id;

      updatePrinters(null, [null], [newData]).then(() => {
        closeDialog();
      });
    }
  }, [selectedOption]);

  useEffect(() => {
    let active = true;

    (async () => {
      const merchants = await search(searchValue);
      if (active) {
        setOptions(merchants);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <>
      <DialogContent>
        <Typography variant={"h6"}>Select merchant</Typography>
        <Autocomplete
          style={{ width: 300 }}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
            setSearchValue("");
          }}
          filterOptions={(x) => x}
          onChange={(e, value) => {
            if (value) {
              setSelectedOption(value);
            }
          }}
          onInputChange={(event, value) => {
            setSearchValue(value);
          }}
          getOptionLabel={(option) => option.name + " - " + option.merchant_id}
          options={options}
          loading={loading}
          renderInput={(params) => (
            <TextField
              {...params}
              label={props.intl.formatMessage({ id: "Search" })}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </DialogContent>
    </>
  );
}

export default withIntl(DuplicatePrinter);
